import ClickToShow from './click-to-show.js';
import GTM from '../gtm/gtm.js';

const pluginName = 'click-to-show';
const elements   = '[data-click-to-show]';

export default {
    init() {
        let gtm = new GTM();
        gtm.init();

        $.fn[pluginName] = function() {
            return this.each((i, el) => {
                let clickToShow = new ClickToShow(el, gtm);
                clickToShow.mask();
            });
        };

        // Not binding on the document because event delegation doesn't work correctly in Safari mobile.
        // @see https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        $('body .main').on('click.toShow', elements, e => {
            e.preventDefault();
            return new ClickToShow($('<span />'), gtm).reveal(e);
        });

        $(elements)[pluginName]();
        $(document).on('enhance:ajaxload', () => {
            $(elements)[pluginName]();
        });
    }
};
